var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcConfig(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 2C3.448 2 3 2.448 3 3V7C3 7.552 3.448 8 4 8H6V18C6 19.0931 6.90694 20 8 20H13V20.5C13 21.3171 13.6829 22 14.5 22H19.5C20.3171 22 21 21.3171 21 20.5V17.5C21 16.6829 20.3171 16 19.5 16H14.5C13.6829 16 13 16.6829 13 17.5V18H8V12H13V12.5C13 13.3171 13.6829 14 14.5 14H19.5C20.3171 14 21 13.3171 21 12.5V9.5C21 8.68294 20.3171 8 19.5 8H14.5C13.6829 8 13 8.68294 13 9.5V10H8V8H10C10.552 8 11 7.552 11 7V3C11 2.448 10.552 2 10 2H4ZM15 10H19V12H15V10ZM15 18H19V20H15V18Z",
    fill: "#E6E6E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcConfig);
export default __webpack_public_path__ + "static/media/ic_config.f078c7384f277662635acc743ba9e3ab.svg";
export { ForwardRef as ReactComponent };